import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResponseStatus } from '@certemy/common';
import { Certification } from '../../../objects/certification.object';
import { getSection } from 'utils/helpers';
import { PublishCertificationData } from 'services/certs/certification.interface';
import { BriefNotificationsSettings } from 'features/organization-settings/notifications/organization-notifications.constants';

export class CertificationResponse {
  data: Certification = null;
  status = ResponseStatus.INITIAL;
  defaultEducationActivitiesState = {
    status: ResponseStatus.INITIAL,
    activities: [],
  };
  shouldPublishAfterImageUpload = false;
  publishCertificationData: PublishCertificationData = null;
  briefNotificationsSettings: BriefNotificationsSettings = null;
}

export namespace Selectors {
  export const getCertificationResponse = createFeatureSelector<CertificationResponse>('certification');
  export const getCertification = createSelector(
    getCertificationResponse,
    (certificationResponse) => certificationResponse.data,
  );
  export const isOldVersion = createSelector(getCertification, (certification: Certification) => {
    return (
      'isLatestVersion' in certification &&
      !certification.isLatestVersion &&
      getSection(window.location.pathname) !== 'imposer'
    );
  });

  export const getCertificationLogo = createSelector(getCertification, (certification) => certification.avatar);

  export const getEducationDefaultActivitiesState = createSelector(
    getCertificationResponse,
    (certification) => certification.defaultEducationActivitiesState,
  );

  export const getEducationDefaultActivities = createSelector(
    getEducationDefaultActivitiesState,
    (actvitiesState) => actvitiesState.activities,
  );

  export const getIsPublishAfterImageUpload = createSelector(
    getCertificationResponse,
    (certification) => certification.shouldPublishAfterImageUpload,
  );

  export const getPublishCertificationData = createSelector(
    getCertificationResponse,
    (certification) => certification.publishCertificationData,
  );

  export const selectBriefNotificationsSettingsCert = createSelector(
    getCertificationResponse,
    (certification: CertificationResponse) => certification.briefNotificationsSettings,
  );
}
